import { render, staticRenderFns } from "./UpdateValueDialog.vue?vue&type=template&id=40c7a0a2"
import script from "./UpdateValueDialog.vue?vue&type=script&lang=js"
export * from "./UpdateValueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports